import { AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery } from '@festina/moneyin-general-types/moneyin/hooks/AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery'

export const useFetchPostingsFromMoneyIn =
  AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery.useSuspenseQuery
